module.exports = __webpack_public_path__ + "static/media/icon_search.3fb3d097.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_search.svg
// module id = 299
// module chunks = 0